module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pass-register:title":"Реестр пропусков","pass-register:add-button":"Добавить пропуск"},"en":{"pass-register:title":"Pass register","pass-register:add-button":"Add pass"}}')
  delete Component.options._Ctor
}
